<template>
  <div class="ds-control mobile ds_teas_select_field" :style="{'height':isDesign?'200px':''}">
    <van-popup v-model="show" round position="bottom" @click-overlay="$emit('close')" v-if="!isDesign">
      <div class="select_field_box">
        <div class="select_field_title">
          <div></div>
          <span>选择场地</span>
          <i class="iconfont icon-icon-close" @click="$emit('close')"></i>
        </div>
        <van-tabs v-model="active" @click="changeTab" :ellipsis="false">
          <van-tab :title="item.name" v-for="(item,index) of nodes" :key="index">
            <div class="tabs_content">
              <div class="tabs_left">
                <div v-for="(items,indexs) of item.children" :key="indexs" :class="buildingValue==indexs?'building':''" @click="buildingClick(items,indexs)">{{items.name}}</div>
              </div>
              <div class="tabs_right" v-if="classroomArr.length">
                <div :class="[element.relName && element.relName.length>6?'long_value':'',element.check?'selected_value':'']" v-for="(element,elindex) of classroomArr" :key="elindex" @click="selectPlace(element,elindex)">{{element.relName || ''}}</div>
              </div>
            </div>
            <div class="tabs_btn_box">
              <div class="btn_cz" @click="clearData">重置</div>
              <div class="btn_sure" :class="selectPlaceArr.length?'':'ash_sure'" @click="onConfirm">确定</div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMobileSelectField",
  ctrlCaption: "场地选择",
  mixins: [$mixins.control],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    isCheckbox: {
      type: Boolean,
      default: false
    },
    selectAll: {
      type: Boolean,
      default: true
    },
    echoData: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      nodes: [],
      buildingValue: 0,
      classroomArr: [],
      selectPlaceArr: [],
      active: 0
    }
  },
  watch: {
    show(newValue, oldValue) {
      if (newValue) {
        this.getField();
      }
    },
    echoData(newValue, oldValue) {
      if (newValue && newValue.length) {
        newValue.forEach(element => {
          this.selectPlaceArr.push({
            id: element
          })
        })
      }
    }
  },
  methods: {
    // 重置数据
    clearData() {
      this.selectPlaceArr = [];
      this.classroomArr.forEach((element) => {
        element.check = false;
      })
    },
    // 确定场地选择
    onConfirm() {
      if (!this.selectPlaceArr.length) return
      this.selectPlaceArr.forEach(element => {
        element.inheritName = element.inheritName || element.relName;
      })
      this.$emit('choose-data', this.selectPlaceArr);
    },
    // 切换场地tab页
    changeTab(name, title) {
      this.getChildField(this.nodes[name].id, this.nodes[name].name)
      this.buildingValue = 0;
    },
    // 切换场地楼宇
    buildingClick(v, i) {
      if (v.id) {
        let name = v.inheritName || v.name;
        this.getChildField(v.id, name)
        this.buildingValue = i;
      }
    },
    // 选择场地教室
    selectPlace(v, i) {
      let { isCheckbox, classroomArr, selectPlaceArr } = this;
      //   是否多选
      if (isCheckbox) {
        classroomArr[i].check = !classroomArr[i].check;
        // 是否选中
        if (classroomArr[i].check) {
          selectPlaceArr.push(v)
        } else {
          selectPlaceArr.forEach((element, index) => {
            if (v.id == element.id) {
              selectPlaceArr.splice(index, 1)
            }
          })
        }
      } else {
        this.selectPlaceArr = [v]
        this.cleanData()
      }
    },
    // 清洗数据
    cleanData() {
      let objectVal = {};
      this.selectPlaceArr.forEach(element => {
        objectVal[element.id] = element;
      })
      this.classroomArr.forEach(element => {
        if (objectVal[element.id] && element.id == objectVal[element.id].id) {
          element.check = true;
        } else {
          element.check = false;
        }
      })
    },

    //   获取场地
    getField() {
      this.$http
        .get("resource/occupy/getParentPlaceInfo")
        .done((res) => {
          if (res.data && res.success && res.state == 20000) {
            let arr = res.data;
            arr.forEach((element) => {
              if (element.children) {
                element.children?.unshift({
                  name: '全部',
                  inheritName: element.name,
                  id: element.id
                })
              } else {
                element.children = [{
                  name: '全部',
                  inheritName: element.name,
                  id: element.id
                }]
              }

            })
            this.nodes = JSON.parse(JSON.stringify(arr))
            if (res.data && res.data.length) {
              let name = res.data[0].inheritName || res.data[0].name;
              this.getChildField(res.data[this.active].id, name)
            }
          }
        }).error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
        .always(() => {
        });
    },
    // 获取教室
    getChildField(val, name) {
      this.$http
        .get("resource/occupy/getPlaceInfoByPid", { pid: val })
        .done((res) => {
          if (res.data && res.success && res.state == 20000) {
            if (res.data.length && this.selectAll) {
              this.classroomArr = [{ relName: '全部', id: val, inheritName: name }, ...res.data];
            } else {
              this.classroomArr = res.data;
            }
            this.classroomArr.forEach(element => {
              element.check = false;
            });
            this.classroomArr = JSON.parse(JSON.stringify(this.classroomArr));
            this.cleanData();
          }
        }).error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
        .always(() => {
        });
    },
  },
  created() {
    if (this.show) {
      this.getField();
    }
  }
})
</script>

<style>
</style>